<div id="left-sidebar" class="sidebar-sticky h-100">
    <div class="pl-4 d-flex flex-row">
        <div class="p-1">
            <img
                src="/assets/img/united-kingdom.png"
                [ngClass]="{ 'flag-selected': currentLangEnglish() }"
                class="flag-icon"
                alt=""
                (click)="setLanguageEnglish()"
            />
        </div>
        <div class="p-1">
            <img
                src="/assets/img/italy.png"
                [ngClass]="{ 'flag-selected': currentLangItalian() }"
                class="flag-icon"
                alt=""
                (click)="setLanguageItalian()"
            />
        </div>
        <div class="p-1">
            <img
                src="/assets/img/france.png"
                [ngClass]="{ 'flag-selected': currentLangFrench() }"
                class="flag-icon"
                alt=""
                (click)="setLanguageFrench()"
            />
        </div>
    </div>
    <div class="company-logo px-4">
        <nav class="navbar flex-md-nowrap mt-0 sidebar-button">
            <button class="btn" (click)="toggleSidebar()">
                <i class="fas fa-bars"></i>
            </button>
        </nav>
        <img class="sidebar-logo d-block m-auto" src="assets/img/img_logo.png" />
    </div>
    <ul class="nav flex-column px-1 pt-4 w-100 sidebar-list">
        <li class="nav-item">
            <div *ngFor="let item of sidebarItems" class="sidebar-item">
                <a
                    class="nav-link btn p-0 m-0 py-2 text-left"
                    [ngClass]="{ father: !item.isCollapsed }"
                    [attr.aria-expanded]="item.isCollapsed"
                    (click)="toggleCollapsed(item)"
                    aria-controls="collapse"
                    (mouseover)="onItemHover(item)"
                    (mouseout)="onItemOut(item)"
                >
                    <i class="fas fa-fw {{ item.icon }} mx-3 sidebar-icon"></i>
                    <span>{{ item.label | translate }}</span>
                </a>
                <div
                    id="collapse"
                    class="p-0"
                    *ngIf="item.children && item.children.length > 0"
                    [ngbCollapse]="item.isCollapsed"
                >
                    <div *ngFor="let child of item.children" class="sidebar-item">
                        <a
                            class="nav-link btn p-0 m-0 py-2 child text-justify"
                            (click)="onClick(child)"
                            [ngClass]="{ 'child-active': child.isActive }"
                        >
                            <i class="fa fa-caret-right mx-3" aria-hidden="true"></i>
                            <span>{{ child.label | translate }}</span>
                        </a>
                    </div>
                </div>
            </div>
        </li>
    </ul>
</div>
